import api from '../api';

export const allJobsInfo = async (page) => {
    
        const res = await api.get(`/job/getAllJobsInfo${page ? '?page=' + page : ''}`);
        return res.data.jobs;
    
}

export const allCancelledJobsInfo = async (page) => {
    
        const res = await api.get(`/job/getAllCancelledJobsInfo${page ? '?page=' + page : ''}`);
        return res.data.jobs;
    
}

export const manualCapture = async (jobId, shovellerId, role) => {
    
        const res = await api.post('/job/markJobAsCompleted', { jobId, shovellerId, role });
        return res.data;
    
}


export const enableCancelButtonForHomeOwner = async (jobId) => {
    
        const res = await api.post('/job/houseOwnerRequestedForCancel', { jobId });
        return res.data;
    
}

export const getCombinedServicesJobs = async (page, limit) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        const query = params.toString();
        const res = await api.get(`/job/combined-services${query ? `?${query}` : ''}`);
        console.log("api res", res)
        return res.data.jobs;
}

export const updateCombinedServiceJob = async (jobId, payload) => {
        const res = await api.patch(`/job/combined-services/${jobId}`, payload);
        return res.data;
}